/**
 * <s-product-gallery> — mobile pagination dots for the product media carousel.
 * The gallery itself is a native scroll-snap row ([data-product-gallery]); this element
 * marks the dot of the slide in view and scrolls to a slide when its dot is pressed.
 * From the md breakpoint up the dots are hidden and the gallery is a static grid.
 */
class SProductGallery extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    const track = this.querySelector('[data-product-gallery]');
    const dots = [...this.querySelectorAll('[data-gallery-dot]')];
    if (!track || dots.length < 2) return;

    const sync = () => {
      const index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      const current = Math.min(Math.max(Math.abs(index), 0), dots.length - 1);
      dots.forEach((dot, i) => dot.setAttribute('aria-current', i === current ? 'true' : 'false'));
    };

    let frame = 0;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(sync);
    }, { ...opts, passive: true });

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        const slide = track.children[i];
        if (!slide) return;
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      }, opts);
    });

    sync();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-product-gallery')) {
  customElements.define('s-product-gallery', SProductGallery);
}
